import "../css/dashboard.css";
import TopTitleBannerMobile from "../component/TopTitleBannerMobile";
import MAVideoLinks from "../component/Misc/MAVideoLinks";

export default function MobileAppSetContent() {

  return (
    <div className="right-container">
      <TopTitleBannerMobile title={"Client Mobile App Settings"} />
      <MAVideoLinks />
    </div>
  );
}
